import { useMemo } from "react";

import { copy } from "shared/assets";
import { IAPIError, IJSONAPIErrorCodes } from "shared/types";

const messages = copy.subscription.messages;

export const useSubscriptionError = (apiError?: IAPIError | null) => {
  const error = useMemo(() => {
    const { errorCodes } = apiError || {};

    if (errorCodes?.includes(IJSONAPIErrorCodes.OverlappingSubsriptions)) {
      return messages.overlapping;
    }

    if (errorCodes?.includes(IJSONAPIErrorCodes.NumericTooLowError)) {
      return messages.startBeforeEnd;
    }

    return !!apiError;
  }, [apiError]);

  return { error };
};
